import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'provider-schedules', {
        params,
      })
      .then(
        ({ data }) => {
          let profiles = [];
          if (data.data) {
            profiles.data = data.data;
          }
          resolve(profiles);
        },
        (error) => {
          reject(error);
        }
      );
  });

  return promise;
};
